module.exports = __webpack_public_path__ + "img/device_i.cea51ca7.png";